(function(app) {

    app.provider("externalTenantApi",
    [
        function() {
            this.$get = [
                "externalsApiGateway", function(externalsApiGateway) {
                    var service = {};

                    service.getMarketingTrackerAccessGroup = function() {
                        return externalsApiGateway.get("/Tenants/MarketingTracker/AccessGroup");
                    }

                    return service;
                }
            ];
        }
    ]);
})(window.app);